// VAT_PERCENTAGES is a map of country codes to VAT percentages
// Each country in this object has resident-only VAT rates
const VAT_PERCENTAGES: Record<string, number> = {
  AR: 21,
  CL: 19,
  CO: 19,
  IL: 18,
  PE: 18
}

// VAT_EXEMPT_CITY_IDS is an array of city IDs that are exempt from VAT (e.g. Eilat city in Israel)
const VAT_EXEMPT_CITY_IDS = ['143']

// Get the resident-only VAT rate for a given country code
export const getResidentVatRate = (countryCode: string) => {
  return VAT_PERCENTAGES[countryCode] || 0
}

// Check if the given country has resident-only VAT rates and the city is not exempt from VAT
export const hasResidentOnlyVAT = (countryCode?: string, cityId?: string) => {
  if (!countryCode || !cityId) return false

  return (
    Object.keys(VAT_PERCENTAGES).includes(countryCode) &&
    !VAT_EXEMPT_CITY_IDS.includes(cityId)
  )
}

// Only IL must show "Additional charges may apply" to non-residents, for price compliance.
export const getHasILResidentVAT = (countryCode?: string, cityId?: string) =>
  countryCode === 'IL' && hasResidentOnlyVAT(countryCode, cityId)
